import { getStyle } from 'utils';

export const getLibraryDroppableSize = (element: HTMLElement) => {
  // calc library dimensions bigger (with FAKE_SIZE) than in reality
  // for droppables to be properly removed on edges
  const FAKE_SIZE = 200;
  const position = element.getBoundingClientRect();
  const styles = getStyle(element);
  const width = parseInt(styles.width, 10) + FAKE_SIZE;
  const height = parseInt(styles.height, 10) + (2 * FAKE_SIZE);

  return {
    width,
    height,
    x: position.left,
    y: position.top - FAKE_SIZE,
  };
};

export const getLibraryBoxSize = (element: HTMLElement) => {
  const styles = getStyle(element);
  const width = parseInt(styles.width, 10) || 0;
  const height = parseInt(styles.height, 10) || 0;
  const margin = parseInt(styles.paddingLeft, 10) || 0;

  return {
    width,
    height,
    margin,
  };
};
